import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#FF4C51",
      "fill-opacity": ".16",
      d: "M0 6a6 6 0 0 1 6-6h18a6 6 0 0 1 6 6v18a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#FF4C51",
      d: "M15 24.166A9.166 9.166 0 0 1 5.835 15a9.167 9.167 0 0 1 9.167-9.167A9.166 9.166 0 0 1 24.167 15a9.166 9.166 0 0 1-9.166 9.166m0-1.833a7.333 7.333 0 1 0 0-14.666 7.333 7.333 0 0 0 0 14.666m-.916-4.583h1.833v1.833h-1.833zm0-7.334h1.833v5.5h-1.833z"
    }, null, -1)
  ]))]))
}
export default { render: render }